import { render } from "./student-name-cell.vue?vue&type=template&id=32139746"
import script from "./student-name-cell.vue?vue&type=script&setup=true&lang=js"
export * from "./student-name-cell.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/common/shared/components/student-name-cell.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32139746"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32139746', __exports__)) {
    api.reload('32139746', __exports__)
  }
  
  module.hot.accept("./student-name-cell.vue?vue&type=template&id=32139746", () => {
    api.rerender('32139746', render)
  })

}


export default __exports__